import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";

const DashboardEcommerce = () => {
  document.title = "Dashboard | AICare";
  const [filterDate, setFilterDate] = useState(new Date().getMonth());

  const [rightColumn, setRightColumn] = useState<boolean>(true);

  return (
    <React.Fragment>
      <Container style={{ height: "100%" }} fluid>
        <Row>
          <Col>
            <div
              className="page-content"
              style={{
                marginTop: "100px",
                height: "100vh", // Imposta l'altezza a 100% della viewport
                width: "100%", // Imposta la larghezza a 100% della viewport
                backgroundImage: `url('dashboard-image-2.jpeg')`, // Percorso immagine
                backgroundSize: "cover", // L'immagine copre l'intero contenitore
                backgroundPosition: "top left", // Centra l'immagine
                backgroundRepeat: "no-repeat", // Evita ripetizioni
              }}
            >
              {" "}
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default DashboardEcommerce;
